import { Algorithm, AlgorithmRepository, ExecutionEnvironment } from '@telespot/domain';

export interface ListAlgorithmsInput {
  searchTerm?: string;
  limit?: number;
  lastItemName?: string;
  environmentFilter?: ExecutionEnvironment;
  includeDeprecated?: boolean;
}

export interface ListAlgorithmsOutput {
  id: string;
  name: string;
  version: string;
  description: string;
  regulated: boolean;
  deprecated: boolean;
  environment: ExecutionEnvironment;
  numOrganizations: number;
  numWorkspaces: number;
}

export interface IListAlgorithmsQuery {
  /**
   * Lists algorithms ordered by name, paginated by `lastItemName` cursor and
   * narrowed by the optional search term, environment filter, and deprecation
   * flag. Repository errors propagate so the caller's pagination effect can
   * surface them.
   */
  execute(input: ListAlgorithmsInput): Promise<ListAlgorithmsOutput[]>;
}

export class ListAlgorithmsQuery implements IListAlgorithmsQuery {
  constructor(private readonly algorithmRepository: AlgorithmRepository) {}

  public async execute(input: ListAlgorithmsInput): Promise<ListAlgorithmsOutput[]> {
    const algorithms = await this.algorithmRepository.list(
      input.searchTerm,
      input.limit,
      input.lastItemName,
      input.environmentFilter,
      input.includeDeprecated
    );
    return algorithms.map((algorithm: Algorithm) => ({
      id: algorithm.id,
      name: algorithm.name,
      version: algorithm.version,
      description: algorithm.description,
      regulated: algorithm.regulated,
      deprecated: algorithm.deprecated,
      environment: algorithm.environment,
      numOrganizations: algorithm.numOrganizations,
      numWorkspaces: algorithm.numWorkspaces,
    }));
  }
}
